var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-v-tocart"},[_c('button',{staticClass:"adv-add-to-cart-button-base",attrs:{"disabled":_vm.disabled},on:{"click":_vm.addToCart}},[_c('span',[_vm._v(_vm._s(_vm.buttonText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }